import { Box, Typography, Chip, Avatar } from "@mui/material";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  MODAL_IMAGE_EDIT_IMAGE_ALT,
  MODAL_IMAGE_EDIT_ORIGINAL_IMAGE_LABEL,
} from "../../../../i18n/keysTranslations";
import AttachmentChip from "./AttachmentChip";
import AttachmentsScrollRow from "./AttachmentsScrollRow";
import {
  ATTACHMENT_CHIP_VARIANTS,
  getDarkBubbleChipSx,
} from "./attachmentChipTheme";

const UserMessage = ({
  content,
  imageUrl,
  attachmentUrls = [],
  attachmentFileNames = {},
  isFirstUserMessage = false,
  onImageClick,
}) => {
  const { t } = useTranslationApp();
  const hasAttachments = attachmentUrls?.length > 0;

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      {hasAttachments ? (
        <AttachmentsScrollRow>
          {attachmentUrls.map((url, idx) => (
            <AttachmentChip
              key={`${url}-${idx}`}
              url={url}
              fileName={attachmentFileNames[url] || `imagen-${idx + 1}.png`}
              variant={ATTACHMENT_CHIP_VARIANTS.DARK}
            />
          ))}
        </AttachmentsScrollRow>
      ) : null}

      <Box>
        <Typography
          variant="body2"
          sx={{ mb: imageUrl && isFirstUserMessage ? 1 : 0 }}
        >
          {content}
        </Typography>
        {imageUrl && isFirstUserMessage ? (
          <Chip
            avatar={
              <Avatar
                src={imageUrl}
                alt={t(MODAL_IMAGE_EDIT_IMAGE_ALT)}
                sx={{
                  width: 24,
                  height: 24,
                  border: "1px solid rgba(255, 255, 255, 0.2)",
                }}
              />
            }
            label={t(MODAL_IMAGE_EDIT_ORIGINAL_IMAGE_LABEL)}
            size="small"
            onClick={onImageClick}
            sx={{
              ...getDarkBubbleChipSx(),
              cursor: "pointer",
              "& .MuiChip-avatar": {
                width: 24,
                height: 24,
              },
            }}
          />
        ) : null}
      </Box>
    </Box>
  );
};

export default UserMessage;
